import * as React from "react";

const CheckmarkAppFilled = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18.3691 17.998" {...props}>
      <g>
        <rect height={17.998} opacity={0} width={18.3691} x={0} y={0} />
        <path d="M16.6211 1.37695C17.5293 2.27539 18.0078 3.61328 18.0078 5.32227L18.0078 12.6758C18.0078 14.3848 17.5293 15.7227 16.6211 16.6211C15.7422 17.5 14.4043 17.998 12.6855 17.998L5.3125 17.998C3.60352 17.998 2.26562 17.5098 1.37695 16.6211C0.46875 15.7227 0 14.3848 0 12.6758L0 5.32227C0 3.61328 0.478516 2.27539 1.37695 1.37695C2.25586 0.498047 3.60352 0 5.3125 0L12.6855 0C14.4043 0 15.7324 0.488281 16.6211 1.37695ZM12.0312 5.11719L7.85156 11.8164L5.86914 9.25781C5.63477 8.93555 5.41016 8.84766 5.13672 8.84766C4.6875 8.84766 4.3457 9.20898 4.3457 9.64844C4.3457 9.87305 4.43359 10.0879 4.58008 10.2832L7.03125 13.291C7.29492 13.6328 7.55859 13.7695 7.90039 13.7695C8.23242 13.7695 8.50586 13.6133 8.71094 13.291L13.3008 6.06445C13.4277 5.85938 13.5449 5.63477 13.5449 5.41992C13.5449 4.96094 13.1543 4.66797 12.7246 4.66797C12.4609 4.66797 12.207 4.82422 12.0312 5.11719Z" />
      </g>
    </svg>
  );
};

export default CheckmarkAppFilled;
